import { useState, useRef } from "react";
import { LENDERS_ALWAYS_VISIBLE, LENDERS_EXPANDABLE } from "@/data/lenders";

function LenderItem({ name }) {
  return (
    <li>
      <span className="lender-check-icon" aria-hidden="true">
        <svg viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
          <circle cx="10" cy="10" r="10" fill="#5bbcbd"/>
          <path d="M5.5 10.5L8.5 13.5L14.5 7.5" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
        </svg>
      </span>
      {name}
    </li>
  );
}

function LenderCol({ letter, items }) {
  return (
    <div className="lender-column">
      <h3 className="lender-letter">{letter}</h3>
      <ul>
        {items.map((name) => <LenderItem key={name} name={name} />)}
      </ul>
    </div>
  );
}

function LenderGrid({ groups }) {
  const pairs = [];
  for (let i = 0; i < groups.length; i += 2) {
    pairs.push(groups.slice(i, i + 2));
  }
  return (
    <>
      {pairs.map((pair) => (
        <div key={pair[0].letter} className="lender-columns">
          {pair.map((g) => <LenderCol key={g.letter} letter={g.letter} items={g.items} />)}
          {pair.length === 1 && <div className="lender-column" />}
        </div>
      ))}
    </>
  );
}

export default function LenderSection() {
  const [showExtra, setShowExtra] = useState(false);
  const sectionRef = useRef(null);

  function handleToggle() {
    if (showExtra) {
      setShowExtra(false);
      setTimeout(() => {
        sectionRef.current?.scrollIntoView({ behavior: "smooth", block: "start" });
      }, 10);
    } else {
      setShowExtra(true);
    }
  }

  return (
    <section className="lender-section" data-testid="lender-section" ref={sectionRef}>
      <div className="lender-card">
        <h2>Is Your Lender On The List?</h2>
        <p className="sub">We&#39;ll find any vehicle finance agreements to ease your claim</p>

        <div className="lender-columns">
          {LENDERS_ALWAYS_VISIBLE.map((g) => (
            <LenderCol key={g.letter} letter={g.letter} items={g.items} />
          ))}
        </div>

        <div className={`lender-extra-wrap${showExtra ? " show" : ""}`} data-testid="lender-extra">
          <LenderGrid groups={LENDERS_EXPANDABLE} />
        </div>
      </div>

      <button
        className="btn-teal-lg"
        onClick={handleToggle}
        data-testid="view-all-lenders-btn"
      >
        {showExtra ? "Show fewer lenders" : "View all lenders"}
      </button>
    </section>
  );
}
